<template>
  <mesAccueils v-bind="$props"></mesAccueils>
</template>

<script>
import mesAccueils from '@/components/mesAccueils.vue'

export default {
  name: 'accueils',
  props: [
    'status'
  ],
  components: {
    mesAccueils
  }
}
</script>
